import type { CSSProperties } from 'react';
import { connect } from 'react-redux';
import { closeToast } from 'Store/toast/toast.actions';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Toast } from './Toast';

type ToastState = {
  className?: string;
  color?: Colors;
  icon?: IconName;
  label?: string;
  shouldDisplay?: boolean;
  style?: CSSProperties;
};

type ContainerProps = {
  className?: string;
  color?: Colors;
  icon?: IconName;
  label?: string;
  style?: CSSProperties;
  visible?: boolean;
};

export const mapStateToProps = (state: ReduxState = {}): ContainerProps => {
  const { className, color, icon, label, shouldDisplay, style } =
    (state.toast as ToastState | undefined) ?? {};
  return {
    className,
    color,
    icon,
    label,
    style,
    visible: shouldDisplay,
  };
};
const mapDispatchToProps = {
  onClose: closeToast,
};
export const ToastContainer = connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Toast);
